import type { ApolloError } from '@apollo/client';
import { useQuery } from '@apollo/client';

import { get as getUser } from 'js/lib/user';

import type {
  AiCoachPlatform_ChatSessionsByUserQuery as ChatSessionsByUserQuery,
  AiCoachPlatform_ChatSessionsByUserQueryVariables as ChatSessionsByUserQueryVariables,
  AiCoachPlatform_ChatSessionsByUser_CoachChatSessionFragment as CoachChatSessionFragment,
} from 'bundles/ai-coach-platform/queries/__generated__/aiCoachChatSessionsByUser';
import aiCoachChatSessionsByUserQuery from 'bundles/ai-coach-platform/queries/aiCoachChatSessionsByUser.graphql';
import { captureMessageInSentry } from 'bundles/ai-coach-platform/utils/sentry';

const useCoachSessions = ({
  settingsEnabled,
}: {
  settingsEnabled: boolean;
}): {
  loading: boolean;
  error?: ApolloError;
  sessions: CoachChatSessionFragment[];
} => {
  const {
    data: queryData,
    loading,
    error,
  } = useQuery<ChatSessionsByUserQuery, ChatSessionsByUserQueryVariables>(aiCoachChatSessionsByUserQuery, {
    variables: {
      userId: (getUser().id || '').toString(),
    },
    context: { clientName: 'gatewayGql' },
    fetchPolicy: 'network-only',
    skip: !settingsEnabled,
  });

  const sessions = queryData?.AiCoach?.queryChatSessionsByUserId.elements as CoachChatSessionFragment[];

  if (error) {
    captureMessageInSentry({ error, source: 'queryChatSessionsByUserId' });
  }

  return { sessions, loading, error };
};

export default useCoachSessions;
